import { render } from "./TimestampInRealTime.vue?vue&type=template&id=03d6de02"
import script from "./TimestampInRealTime.vue?vue&type=script&lang=js"
export * from "./TimestampInRealTime.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__